import React from 'react';
import { Link } from 'react-router-dom';
import PageNavigation from '../components/PageNavigation';
import { getAllPosts } from '../posts/posts';
import './Page.css';
import './Blog.css';

function Blog() {
  const posts = getAllPosts();

  return (
    <div className="page-container">
      <PageNavigation />
      <div className="page-content">
        <div className="blog-list">
          {posts.length === 0 ? (
            <p className="page-text">No blog posts yet. Check back soon!</p>
          ) : (
            posts.map((post) => (
              <article key={post.id} className="blog-post-preview">
                <Link to={`/blog/${post.slug}`} className="blog-post-link">
                  <div className="blog-post-preview-header">
                    <h2 className="blog-post-preview-title">{post.title}</h2>
                    <time className="blog-post-preview-date" dateTime={post.date}>
                      {(() => {
                        const [year, month, day] = post.date.split('-');
                        return new Date(parseInt(year), parseInt(month) - 1, parseInt(day)).toLocaleDateString('en-US', {
                          year: 'numeric',
                          month: 'long',
                          day: 'numeric'
                        });
                      })()}
                    </time>
                  </div>
                </Link>
              </article>
            ))
          )}
        </div>
        <Link to="/" className="back-link">← PLAY WITH THE BAGEL</Link>
      </div>
    </div>
  );
}

export default Blog;

